import React from 'react'
import SbEditable from "storyblok-react"
import FluidImage from "src/utils/FluidImage";

const RichTextTwoColumnImage = ({ blok }) => {
    return (
        <SbEditable content={blok}>
            <div className="my-16">
                <div className={`grid gap-x-[23px] gap-y-[30px] ${blok.images?.length > 1 ? 'sm:grid-cols-2 grid-cols-1' : 'grid-cols-1'}`}>
                    {blok.images.map((item, index) => (
                        <SbEditable content={item} key={index}>
                            <div className="w-full">
                                <FluidImage
                                    className="not-prose"
                                    image={item.image}
                                    placeholder="https://via.placeholder.com/1000x1200"
                                />
                                {item.caption &&
                                    <h5 className='italic text-sm font-normal tracking-[0.15px] text-blue mt-2'>{item.caption}</h5>
                                }
                            </div>
                        </SbEditable>
                    ))}
                </div>
            </div>
        </SbEditable>
    )
}

export default RichTextTwoColumnImage